import React from "react";

import { Checkbox } from "affinityUI/form/inputs/checkbox";

import { useAffinityField } from "../../../helpers";

export const CheckboxOption: React.FC<React.PropsWithChildren<{ value: string; name: string }>> = ({
  name,
  value,
  children,
}) => {
  const [fieldData, { error }] = useAffinityField({ name, type: "checkbox", value });

  return (
    <Checkbox {...fieldData} id={`${name}-${value}`} error={error}>
      {children}
    </Checkbox>
  );
};
